import { ExternalSourceTypes } from '@generated/graphql';

const assets = [
  ExternalSourceTypes.Cash,
  ExternalSourceTypes.ExternalInvestmentAccount,
  ExternalSourceTypes.RealEstate,
  ExternalSourceTypes.Vehicles,
  ExternalSourceTypes.Valuables,
  ExternalSourceTypes.OtherAsset,
];
const liabilities = [
  ExternalSourceTypes.Loans,
  ExternalSourceTypes.Mortgage,
  ExternalSourceTypes.CreditCard,
  ExternalSourceTypes.OtherLiability,
];

export const MAP_EXTERNAL_SOURCE_TYPE = { assets, liabilities };

export const getNetWorthType = (
  externalSourceType: ExternalSourceTypes | undefined,
): 'assets' | 'liabilities' | 'unknown' => {
  if (!externalSourceType || assets.includes(externalSourceType))
    return 'assets';
  if (liabilities.includes(externalSourceType)) return 'liabilities';
  return 'unknown';
};
